
import { useNavigate } from 'react-router-dom';
import { useOnboardingState, type OnboardingStep } from './onboarding/useOnboardingState';
import { useEmailVerification } from './onboarding/useEmailVerification';
import { useAppInstallation } from './onboarding/useAppInstallation';
import { useOtpVerifier } from './onboarding/useOtpVerifier';
import { useState, useEffect } from 'react';

export const useOnboardingFlow = () => {
  const navigate = useNavigate();
  const [verifyingPhone, setVerifyingPhone] = useState(false);
  
  useEffect(() => {
    // Remove any phone verification flags
    localStorage.removeItem('verifyingPhone');
    setVerifyingPhone(false);
  }, []);
  
  const {
    step,
    setStep,
    name,
    setName,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
    phoneError,
    setPhoneError,
    expectedOtp,
    setExpectedOtp,
    resendDisabled,
    setResendDisabled,
    countdown,
    setCountdown,
    emailError,
    setEmailError,
    isLoading,
    setIsLoading,
    loadUserData
  } = useOnboardingState();

  const { 
    handleEmailContinue, 
    handleResendOtp,
    sendOtpViaSms
  } = useEmailVerification({
    email,
    name,
    setExpectedOtp,
    setResendDisabled,
    setCountdown,
    setStep,
    setIsLoading,
    setEmailError,
    loadUserData
  });
  
  const {
    handleOtpComplete: verifyOtp,
    isVerifying
  } = useOtpVerifier({
    email,
    name,
    setStep,
    loadUserData
  });
  
  const handleOtpComplete = async (otp: string) => {
    // Only handle email verification, no phone verification
    await verifyOtp(otp);
  };

  const { 
    handleInstallAppContinue, 
    handleInstallAppSkip 
  } = useAppInstallation({
    setStep
  });

  const handleInfoContinue = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate name if needed
    if (name.trim().length < 3) {
      alert("Veuillez entrer un nom valide d'au moins 3 caractères");
      return;
    }
    
    setStep('email');
  };

  const goToInfoStep = () => setStep('info');
  const goToEmailStep = () => setStep('email');
  
  return {
    step,
    name,
    setName,
    email,
    setEmail,
    emailError,
    phoneNumber,
    setPhoneNumber,
    phoneError,
    expectedOtp,
    resendDisabled,
    countdown,
    isLoading,
    verifyingPhone,
    handleInfoContinue,
    handleEmailContinue,
    handleOtpComplete,
    handleResendOtp,
    goToInfoStep,
    goToEmailStep,
    handleInstallAppContinue,
    handleInstallAppSkip
  };
};
